import { useCallback } from 'react';
import { SizeTracker } from '@view-model/models/common/components/SizeTracker';
import type { Size } from '@view-model/models/common/basic';
import type { ModelCommentId } from 'balus-common';

type Props = {
  id: ModelCommentId;
  width: number;
  onSizeChange: (id: ModelCommentId, newSize: Size) => void;
  children: React.ReactNode;
};

// 親コンテナの border-x-6 (左右各 6px) の合計幅
const BORDER_X_WIDTH = 12;

export const ModelCommentContentItemContainer: React.FC<Props> = ({ id, width, onSizeChange, children }: Props) => {
  const handleSizeChanged = useCallback(
    (size: Size) => {
      onSizeChange?.(id, size);
    },
    [id, onSizeChange]
  );

  return (
    <div>
      <SizeTracker onSizeChanged={handleSizeChanged}>
        {/* 親コンテナは border-x-6 (左右各 6px) を持つため、box-sizing: border-box により
            コンテンツ領域は width - BORDER_X_WIDTH になる。width をそのまま渡すと超過して
            textarea 等が右にずれるため、ここで差し引いて合わせる */}
        <div className="px-[14px] py-10 text-3xl" style={{ width: width - BORDER_X_WIDTH }}>
          {children}
        </div>
      </SizeTracker>
    </div>
  );
};
